function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18279"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59553",
    d: "M12.5 169.512a7.489 7.489 0 0 1-7.084-5.1l-.07-.23a7.3 7.3 0 0 1-.346-2.17v-13.637l-4.852 16.2a4.542 4.542 0 0 0 3.184 5.51l30.927 8.282a4.588 4.588 0 0 0 1.152.148 4.459 4.459 0 0 0 4.322-3.27l1.8-5.73zm0 0",
    transform: "translate(0 -132.51)",
    style: {
      fill: "#eceff1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59554",
    d: "M125.321 4.992v23a4.507 4.507 0 0 1-4.5 4.5h-31a5.251 5.251 0 0 1-.58-.04 4.475 4.475 0 0 1-3.9-4.1 2.161 2.161 0 0 1-.02-.36v-23a4.507 4.507 0 0 1 4.5-4.5h31a4.507 4.507 0 0 1 4.5 4.5zm0 0",
    transform: "translate(-77.321 1.508)",
    style: {
      fill: "#eceff1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59555",
    d: "M157.32 68.492a4 4 0 1 1-4-4 4 4 0 0 1 4 4zm0 0",
    transform: "translate(-135.321 -56.492)",
    style: {
      fill: "#ffc107"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59556",
    d: "M163.214 122.327v5.62a4.507 4.507 0 0 1-4.5 4.5h-31a5.252 5.252 0 0 1-.58-.04l20.6-20.6a3.525 3.525 0 0 1 4.96 0zm0 0",
    transform: "translate(-115.214 -98.447)",
    style: {
      fill: "#388e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59557",
    d: "M113.636 200.115H90.015a5.252 5.252 0 0 1-.58-.04 4.475 4.475 0 0 1-3.9-4.1l9.5-9.5a3.525 3.525 0 0 1 4.96 0zm0 0",
    transform: "translate(-77.516 -166.113)",
    style: {
      fill: "#4caf50"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgUploadIcon);
export default __webpack_public_path__ + "static/media/img-upload-icon.5c394db5fd8bd6312a280a47aa112736.svg";
export { ForwardRef as ReactComponent };